export default __webpack_public_path__ + "static/media/veer2.08ae3350.png";